import { LoadingContainer, LoadingText, Spinner } from './style';

interface LoadingProps {
  text?: string;
  show: boolean;
}

const Loading = ({ text, show = false }: LoadingProps) => {
  return (
    <>
      {show && (
        <LoadingContainer>
          <Spinner />
          {text && <LoadingText>{text}</LoadingText>}
        </LoadingContainer>
      )}
    </>
  );
};

export default Loading;